import React, { useState, useEffect } from 'react';
import HomeMobile from './homeMobile'; 
import HomeWeb from './homeWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const HomeRouter = () => {
  const width = useWindowWidth();

  const MOBILE_BREAKPOINT = 768;

  return width < MOBILE_BREAKPOINT ? <HomeMobile /> : <HomeWeb />;
};

export default HomeRouter;